import styled, { css } from 'styled-components';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  hasError: boolean;
  hasPasswordToggle: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: radial-gradient(
      circle at top left,
      hsl(var(--accent) / 0.08),
      transparent 34%
    ),
    linear-gradient(
      180deg,
      hsl(var(--card) / 0.82),
      hsl(var(--background) / 0.84)
    );
  border-radius: 16px;
  padding: 0 16px;
  width: 100%;
  min-width: 0;
  height: 52px;
  border: 1px solid hsl(var(--accent) / 0.14);
  color: hsl(var(--muted-foreground));

  display: flex;
  align-items: center;
  gap: 12px;

  box-shadow: 0 14px 30px hsl(var(--background) / 0.34),
    0 0 0 1px hsl(var(--accent) / 0.05),
    inset 0 1px 0 hsl(var(--foreground) / 0.03);

  transition: border-color 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease,
    color 0.2s ease, transform 0.2s ease;

  input {
    flex: 1;
    width: 100%;
    min-width: 0;
    background: transparent;
    border: 0;
    color: hsl(var(--foreground));
    caret-color: hsl(var(--accent));

    &::placeholder {
      color: hsl(var(--muted-foreground));
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-text-fill-color: hsl(var(--foreground));
      caret-color: hsl(var(--accent));
      box-shadow: 0 0 0px 1000px hsl(var(--card)) inset;
      -webkit-box-shadow: 0 0 0px 1000px hsl(var(--card)) inset;
      transition: background-color 9999s ease-in-out 0s;
      border-radius: 12px;
    }
  }

  svg {
    flex-shrink: 0;
    transition: color 0.2s ease, filter 0.2s ease;
  }

  ${props =>
    props.isFocused &&
    css`
      color: hsl(var(--primary));
      border-color: hsl(var(--accent) / 0.5);
      box-shadow: 0 18px 36px hsl(var(--background) / 0.4),
        0 0 0 4px hsl(var(--accent) / 0.14), 0 0 24px hsl(var(--accent) / 0.12);
      filter: brightness(1.03);
      transform: translateY(-1px);
    `}

  ${props =>
    props.isFilled &&
    !props.isFocused &&
    !props.hasError &&
    css`
      color: hsl(142 78% 62%);
      border-color: hsl(142 78% 62% / 0.5);
      box-shadow: 0 14px 30px hsl(var(--background) / 0.34),
        0 0 0 3px hsl(142 78% 62% / 0.08), 0 0 20px hsl(142 78% 62% / 0.08);
    `}

  ${props =>
    props.hasError &&
    !props.isFocused &&
    css`
      color: #ff7a7a;
      border-color: #ff6b6b;
      box-shadow: 0 14px 30px hsl(var(--background) / 0.34),
        0 0 0 3px rgb(255 107 107 / 0.12), 0 0 20px rgb(255 107 107 / 0.08);
    `}

  ${props =>
    props.hasPasswordToggle &&
    css`
      input {
        padding-right: 4px;
      }
    `}

  .togglePassword {
    border: 0;
    background: transparent;
    color: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    margin: 0;
    flex: 0 0 auto;
    transition: color 0.2s ease, transform 0.2s ease, filter 0.2s ease;

    &:hover {
      color: hsl(var(--foreground));
      transform: scale(1.03);
      filter: drop-shadow(0 0 8px hsl(var(--accent) / 0.18));
    }
  }
`;
